"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Icon = _styledComponents["default"].svg.withConfig({
  displayName: "CloseIcon__Icon",
  componentId: "sc-19ec855-0"
})(["&:hover{path{fill:", ";}}"], function (props) {
  return (props.hoverColor ? props.hoverColor : '#C32D7B') || 'auto';
});

var CloseIcon = function CloseIcon(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement(Icon, _extends({}, props, {
      viewBox: "0 0 32 32"
    }),
    /*#__PURE__*/
    _react["default"].createElement("path", {
      d: "M16 11.636l-11.636-11.636-4.364 4.364 11.636 11.636-11.636 11.636 4.364 4.364 11.636-11.636 11.636 11.636 4.364-4.364-11.636-11.636 11.636-11.636-4.364-4.364z"
    }))
  );
};

var _default = CloseIcon;
exports["default"] = _default;